import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import { PORTFOLIO_TOKENS } from './tokens';
import type { PortfolioTotals as PortfolioTotalsType } from '../../lib/portfolioApi';

interface Props {
  totals: PortfolioTotalsType;
}

interface CellProps {
  value: string;
  unit?: string;
  label: string;
  color?: string;
  hero?: boolean;
  /** Provenance line — only used where it conveys real trust signal
      (e.g., federal/state data sources). Most cells should omit. */
  provenance?: string;
}

const Cell: React.FC<CellProps> = ({ value, unit, label, color, hero, provenance }) => (
  <div style={{ flex: 1, padding: '14px 16px', background: REPORT.surface, borderRight: `1px solid ${REPORT.rule}` }}>
    <div style={{
      fontFamily: PORTFOLIO_TOKENS.serif,
      fontSize: 26,
      fontWeight: 400,
      color: hero ? REPORT.accent : (color || REPORT.heading),
      lineHeight: 1.05,
      letterSpacing: '-0.005em',
    }}>
      {value}
      {unit && (
        <span style={{
          fontFamily: PORTFOLIO_TOKENS.mono,
          fontSize: 11,
          color: REPORT.tertiary,
          marginLeft: 3,
          fontWeight: 400,
          letterSpacing: '0.04em',
        }}>{unit}</span>
      )}
    </div>
    <div style={{
      fontFamily: PORTFOLIO_TOKENS.mono,
      fontSize: 9.5,
      fontWeight: 700,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: REPORT.body,
      marginTop: 6,
    }}>{label}</div>
    {provenance && (
      <div style={{
        fontFamily: PORTFOLIO_TOKENS.mono,
        fontSize: 9,
        color: REPORT.secondary,
        marginTop: 3,
        letterSpacing: '0.04em',
      }}>{provenance}</div>
    )}
  </div>
);

const fmt = (n: number) => n.toLocaleString();

export const PortfolioTotals: React.FC<Props> = ({ totals }) => (
  <section style={{ display: 'flex', marginBottom: 24, borderRadius: 6, overflow: 'hidden' }}>
    <Cell hero value={String(totals.sites)} label="Sites Reviewed" />
    <Cell value={fmt(totals.acres_total)} unit="ac" label="Total Acreage" />
    <Cell value={String(totals.loi_ready_count)} unit={`of ${totals.sites}`} label="LOI-Ready" color={REPORT.passText} />
    <Cell value={String(totals.fixable_count)} unit="sites" label="Fixable < 90d" color={REPORT.cautionText} />
    <Cell value={String(totals.drop_count)} unit="sites" label="Drop" color={REPORT.failText} />
  </section>
);
